import React, { useEffect, useState } from 'react';
import { ExcelRenderer, OutTable } from 'react-excel-renderer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  BackButton,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import ExcelSheetGenerator from '@iarc-programing/emanufac-components/src/components/ExcelDownload/ExcelSheetGenerator';
import { Button, Card, CardContent } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import { config } from '@/configs';
import * as actions from '@/redux/actions';

/**
 * @function ImportExcelProduct
 * @description Display a collections or a list of EditProcessTemplateTableView from database
 */

export default function ImportExcelCustomer({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const information = useSelector((state) => state.information);
  const customerType = useSelector((state) => state.customerType);
  const [openDownload, setOpenDownload] = useState(false);
  const [columnList, setColumnList] = useState([]);
  const [artifactDataSet, setArtifactDataSet] = useState([]);
  const [inputData, setInputData] = useState({});
  const [allowUploadToServer, setAllowUploadToServer] = useState(false);

  useEffect(() => {
    dispatch(actions.customerTypeAll({ page: 1, size: config.maxFetchSize }));

    return () => {};
  }, []);

  const fileHandler = (event) => {
    const fileObj = event.target.files[0];

    // just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        setInputData({
          cols: resp.cols,
          rows: resp.rows,
        });
        setAllowUploadToServer(true);
      }
    });
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  useEffect(() => {
    const tempColumnList = [
      {
        label: 'ลำดับที่',
        value: 'index',
      },
      {
        label: 'รหัสคู่ค้า/ลูกค้า',
        value: 'type_code',
      },
      { label: 'ประเภทคุ้ค้า/ลูกค้า', value: 'type' },
      {
        label: 'ขื่อคู้ค้า/ลูกค้า',
        value: 'name',
      },
      { label: 'ประเภทองค์กร', value: 'organization_type' },
      { label: 'ลูกค้า/คู่ค้า หรือ ทั้งคู่', value: 'status' },
      {
        label: 'ที่อยู่',
        value: 'address',
      },
      {
        label: 'หมายเลขประจำตัวผู้เสียภาษี',
        value: 'taxes',
      },
      {
        label: 'หมายเลขโทรศัพท์',
        value: 'phone_number',
      },
      {
        label: 'Fax',
        value: 'phone_number',
      },
      {
        label: 'Email',
        value: 'email',
      },
    ];

    const tempArtifact = {};
    _.map(tempColumnList, (each) => {
      tempArtifact[each?.value] = each?.value;
    });

    console.log('Temp Artifact', [tempArtifact]);
    setColumnList(tempColumnList);
    setArtifactDataSet([tempArtifact]);
    return () => {};
  }, [information]);

  const handleOnFileLoad = async () => {
    try {
      console.log('File Data');
      console.log('-----');

      console.log('Input Data', inputData);
      // ชื่อของ Key จะอยู่ใน แถวที่ index 1 (แถวที่ 2 ใน Excel) และเอาแถวสุดท้ายออก
      const fileDataKey = inputData?.rows?.[1];
      const fileData = _.slice(inputData?.rows, 2);

      console.log('File Data Key', fileDataKey);
      console.log('File Data', fileData);
      const fileInFormat = _.map(fileData, (_fileData) =>
        _.zipObject(fileDataKey, _fileData),
      );

      console.log('File In Format', fileInFormat);
      // Filter Not ALl Field undefined
      const filterNotUndefined = fileInFormat.filter(
        (each) => !_.every(each, _.isUndefined),
      );

      console.log('Filter Undefined', filterNotUndefined);

      await dispatch(actions.customerCreate({ arr: filterNotUndefined }));
      Swal.fire({
        icon: 'success',
        title: 'อัพโหลดข้อมูลสำเร็จ',
      }).then(() => {
        history.goBack();
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: error?.message,
      });
    }
  };

  return (
    <div>
      {renderTitle()}
      <BackButton />
      <div className="my-2">
        <Card>
          <CardContent>
            <div>ดาวน์โหลดเทมเพลต</div>
            <ul className="list-disc list-inside">
              <li>
                ในช่อง ประเภทองค์กร ให้ใส่ว่าเป็น <b>บุคคลธรรมดา</b> หรือ{' '}
                <b>นิติบุคคล</b>
              </li>{' '}
              <li>
                ในช่อง ลูกค้า/คู่ค้า หรือ ทั้งคู่ ให้ใส่ว่าเป็น
                ในกรณีเป็นเฉพาะลูกค้า ให้ใส่คำว่า <b>CUSTOMER</b>
                เป็นเฉพาะคู่ค้า ให้ใส่คำว่า <b>SUPPLIER</b> หรือ
                ในกรณีที่เป็นทั้งคู่ให้ใส่คำว่า <b>BOTH</b>
              </li>{' '}
              <li>
                ในช่องของประเภทลูกค้า / คู่ค้า ให้ใส่ชื่อประเภทลูกค้า / คู่ค้า
                ตามที่ตั้งไว้ ได้แก่
                {_.map(customerType?.rows, (each) => (
                  <span className="mx-1">{each?.name}</span>
                ))}
              </li>
            </ul>
            <Button
              variant="contained"
              className="my-2"
              onClick={() => setOpenDownload(true)}
            >
              ดาวน์โหลด
            </Button>
            {openDownload ? (
              <ExcelSheetGenerator
                columnList={columnList}
                dataSets={artifactDataSet}
                sheetName={'CustomerTemplate'}
                spreadedColumn={''}
              />
            ) : (
              <div></div>
            )}
          </CardContent>
        </Card>
      </div>
      <div className="my-2">
        <Card>
          <CardContent>
            <div>อัพโหลดไฟล์ข้อมูล</div>
            <input type="file" onChange={fileHandler} className="my-2" />
            <div className="flex justify-end">
              {allowUploadToServer && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleOnFileLoad()}
                >
                  อัพโหลดไปที่เซิฟเวอร์
                </Button>
              )}
            </div>
            {inputData?.rows && (
              <OutTable
                data={inputData?.rows}
                columns={inputData?.cols}
                tableClassName="ExcelTable2007"
                tableHeaderRowClass="heading bg-gray-200"
              />
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

ImportExcelCustomer.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ImportExcelCustomer.defaultProps = {
  title: '',
  subtitle: '',
};
